module.exports = __webpack_public_path__ + "media/01_ASANBUDAPEST-Atmosphere01.32fc225b.mp3";